import faqApi from './monash-connect-faq';
import { swapAnchorForExternalLink } from '../../utils/swapAnchorForExternalLink';

export const parseAnswer = (answer) => {
  return swapAnchorForExternalLink(faqApi.cleanAnswer(answer));
};
